import React, { useEffect } from "react";

import { useTranslation } from "react-i18next";

import { JOBTYPE_LIST } from "@shared/employeFormNew/employeForm-constants";
import { Controller, useFormContext, useWatch } from "react-hook-form";

import ListboxSimple from "@components/tailwindComponents/ListboxSimple";

/**
 * @param {Object} props
 * @param {boolean} props.readOnly
 * @returns
 */
export default function DropdownTypeOfEmployment({ readOnly }) {
  const { t: translate } = useTranslation([
    "pages.employés.parcours&Certifications",
    "message"
  ]);
  const { control, trigger, formState } = useFormContext();

  const isSecondaryEmployment = useWatch({
    control,
    name: "isSecondaryEmployment",
    defaultValue: false
  });

  useEffect(() => {
    if (formState.isSubmitted) {
      trigger("jobType");
    }
  }, [formState.isSubmitted, isSecondaryEmployment, trigger]);

  return (
    <Controller
      control={control}
      name="jobType"
      rules={{
        validate: {
          required: (value) =>
            isSecondaryEmployment || Boolean(value?.value)
        }
      }}
      render={({ field: { onChange, value }, fieldState: { invalid } }) => {
        const optionList =
          JOBTYPE_LIST?.map((jobType) => ({
            ...jobType,
            name: translate(jobType.name)
          }))?.sort((a, b) => a.name.localeCompare(b.name)) || [];

        const selectedJobType =
          optionList.find((jobType) => jobType.value === value?.value) || {};

        return (
          <div className="blackSvgColor position_relative arh-mb-3">
            <ListboxSimple
              placeholder={translate("Type d'emploi")}
              optionList={optionList}
              selectedValue={selectedJobType}
              setSelectedValue={onChange}
              label={
                translate("Type d'emploi") +
                (isSecondaryEmployment ? "" : " *")
              }
              noRadio
              withSearch
              readOnly={readOnly || isSecondaryEmployment}
              invalid={invalid}
            />
          </div>
        );
      }}
    />
  );
}
